import { Space } from 'antd';
import { StyledTitle } from 'components/StyledTitle';

interface CardTitleProps {
  formStepIndex?: number;
  title: string;
}
export const CardTitle = ({ formStepIndex, title }: CardTitleProps) => (
  <Space align="center" size="middle">
    {formStepIndex && (
      <StyledTitle level={3} type="secondary">
        {formStepIndex}
      </StyledTitle>
    )}
    <StyledTitle level={4}>{title}</StyledTitle>
  </Space>
);
